import { ActionHandler } from '../../common/actions/core/action-handler';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { Action } from '../../common/actions/core/action';
import { OpenCampaignDialogAction } from './campaign-dialog.action';

/*@ngInject*/
export default class OpenCampaignDialogController
  implements ActionHandler {
  private dialogElement;

  constructor(
    protected $element,
    private $state,
    protected actionDispatcher: ActionDispatcherService
  ) {}

  public $postLink() {
    this.dialogElement = this.$element
      .find('#campaign-dialog')
      .remodal();
    this.actionDispatcher.register(this);
  }
  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenCampaignDialogAction) {
      this.openDialog();
    }
  }
  public onClick() {
    this.close();
  }

  private openDialog() {
    this.dialogElement.open();
  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
    this.$state.go('myAccount');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/campaign-dialog/campaign-dialog.controller.ts